import axios from "axios";

import {
  LandingPageHelper, LocaleHelper,
  PickProgramPageHelper,
  ProgramBannersHelper,
  QuestionnaireHelper
} from "../components/Utilities/CmsHelpers";

const api = process
  .env
  .REACT_APP_ANT1_CMS_BASE_URL
  .concat(process.env.REACT_APP_ANT1_CMS_API_PATH);

const REQUEST_TIMEOUT_MS = process.env.REACT_APP_ANT1_CMS_TIMEOUT ?? 10000;

const CmsService = {

  getContent: (page, lng, options = {}) => {
    return axios
      .get(api.concat(page).concat(!!lng ? "?locale="+lng : ""), {
        timeout: REQUEST_TIMEOUT_MS,
        signal: options.signal,
      })
      .then((response) => {
        return response.data;
      });
  },

  getLandingPageContent: (lng, options) => {
    return CmsService.getContent(LandingPageHelper.PAGE_URL, lng, options);
  },

  getPickProgramPageContent: (lng, options) => {
    return CmsService.getContent(PickProgramPageHelper.PAGE_URL, lng, options);
  },

  getProgramBanners: (lng, options) => {
    return CmsService.getContent(ProgramBannersHelper.PAGE_URL, lng, options);
  },
  getQuestionnaires: (lng, options) => {
    return CmsService.getContent(QuestionnaireHelper.PAGE_URL, lng, options);
  },
  getLocales: (options)=>{
    return CmsService.getContent(LocaleHelper.PAGE_URL, undefined, options);
  }
};

export default CmsService;
